import { groupAdapter, GroupState } from './state';

const { selectAll } = groupAdapter.getSelectors();

export const getGroups = selectAll;
export const getGroupsIsLoading = (state: GroupState) => state.isLoading;
